import DealerError from './DealerError.js'

export class SearchResultsDealerError extends DealerError {}
